/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/*!
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!   @@@                                         @@@@
 *!   @@@   THIS FILE WAS AUTOGENERATED BY TOOL   @@@@
 *!   @@@   CHANGES MUST TARGET SCRIPTS/SWAGGER   @@@@
 *!   @@@                                         @@@@
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
 *!
 */

import {
  _buildQueryString,
  _emptyParams,
  _encode,
  _getBasePath,
  _getRawBasePath,
} from './urls-utils'

/**
 * GET /api/v1/saas/providers
 * Operation: `get-saas-providers`
 * Retrieves the list of Elastic Cloud providers with their regions.
 * @param {boolean} params.productionOnlyRegions When false, the response will include non-production ready regions. Default: true
 * @see 200 The Elastic Cloud providers have been returned. See {@link Array<Provider>}
 * @return {string} A fully-interpolated and escaped URL
 */
export function getSaasProvidersUrl(params: GetSaasProvidersUrlParams = _emptyParams): string {
  const queryString = _buildQueryString({
    production_only_regions:
      params.productionOnlyRegions === undefined ? true : params.productionOnlyRegions,
  })
  const path = `/saas/providers`
  return `${_getRawBasePath()}${path}${queryString}`
}

export interface GetSaasProvidersUrlParams {
  productionOnlyRegions?: boolean | null
}
